import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { embedMessageString } from "../../common/helpers/helper";
import StakingPools from "./components/StakingPools";
import * as actions from "../../store/actions";
import { HeaderStyled, NavLinkStyled } from "./style";
import ConnectButton from "./components/ConnectButton";
import LoadingModal from "../LoadingModal/LoadingModal";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Messages from "../../constants/messages";
import {
  toggleWalletModal,
  setNetwork,
} from "../../store/actions/globalActions";
import WalletModal from "./components/WalletModal";
import { getChainDataByChainId } from "../../utils";
import LogoImg from "./Img/logo.png";
import LogoImgMobile from "./Img/logo_mobile.png";
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './header.css';

const { WALLET_MESSAGE } = Messages;

function Header({ hasMetamask, showWalletList, currentChainId }) {
  const [toggleNavBar, setToggleNavBar] = useState(false); // show and hide navbar mobile
  const [modalLoading, setModalLoading] = useState(false); //for inside modal loading  state
  const loginState = useSelector((state) => state.login);
  const { isLogin, loading } = loginState;
  const globalState = useSelector((state) => state.global);
  const { error } = globalState;
  const dispatch = useDispatch();

  const toggleWalletList = useCallback(
    () => dispatch(toggleWalletModal()),
    [dispatch]
  );

  const toggleNavbarHandler = () => {
    setToggleNavBar((prevState) => !prevState);
    document.querySelector("body").style = `${toggleNavBar ? "" : "overflow:hidden"
      }`;
  };

  const onWalletClickHandler = async (walletType) => {
    if (hasMetamask) {
      setModalLoading(true);
      dispatch(actions.getSignInMsg(walletType));
      let chainData = getChainDataByChainId(currentChainId);
      if (chainData) {
        dispatch(setNetwork(chainData.chainName))
      } else {
        dispatch(
          actions.setError(
            { code: 10 },
            {
              errorTitle: "Wrong Network",
              errorMsg: embedMessageString(
                WALLET_MESSAGE.wrongNetwork.message,
                "chainInfo?.network"
              ),
            }
          )
        )
      };
    } else {
      if (!hasMetamask) {
        dispatch(
          actions.setError(
            { code: 0 },
            {
              errorTitle: "Install Metamask",
              errorMsg: WALLET_MESSAGE.noWallet.message,
              errorBtnLabel: "Go to MetaMask's website",
            }
          )
        );
      } else {
        dispatch(
          actions.setError(
            { code: 10 },
            {
              errorTitle: "Wrong Network",
              errorMsg: embedMessageString(
                WALLET_MESSAGE.wrongNetwork.message,
                "chainInfo?.network"
              ),
            }
          )
        );
      }
    }
  };

  // to toggle loading modal
  useEffect(() => {
    if (!loading) return;
    toggleWalletList(false);
  }, [loading, toggleWalletList]);

  return (
    <div className="header-container">
      <Navbar collapseOnSelect expand="lg" variant="dark" >
        <Navbar.Brand>
          <Link to="/"><img alt="logo" className="brand-logo" src={LogoImg}></img></Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
          </Nav>
          <Nav>
            <Nav className="justify-content-end align-items-center navbar-list" activeKey="/home">

              {/* <Nav.Item>
                <Nav.Link href="https://staking.blockius.io" className="mr-4" target="_blank">Staking</Nav.Link>
              </Nav.Item> */}
              
              <Nav.Item>
                <Nav.Link href="https://launchpad.blockius.io" className="mr-4" target="_blank">Launchpad</Nav.Link>
              </Nav.Item>
              <Nav.Item >
                <Nav.Link href="https://claim.blockius.io" className="mr-4" target="_blank">Claim</Nav.Link>
              </Nav.Item>
              <li className="nav-item text-center dropdown mr-4">
                <a className="nav-link  dropdown-toggle" href="#" data-bs-toggle="dropdown">Staking</a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="/" data-toggle="dropdown" data-target=".dropdown-toggle.in"> BLOS Staking </a></li>
                  <li><a className="dropdown-item" href="/liquidity-mining" data-toggle="dropdown" data-target=".dropdown-toggle.show">BLOS LP Mining </a></li>
                </ul>
              </li>
              <li className="nav-item text-center dropdown mr-4">
                <a className="nav-link  dropdown-toggle" href="#" data-bs-toggle="dropdown">  Vault  </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="https://blockius.io/vault?type=vesting" data-toggle="dropdown" data-target=".dropdown-toggle.in" target="_blank"> Vesting </a></li>
                  <li><a className="dropdown-item" href="https://blockius.io/vault?type=liquidity" data-toggle="dropdown" data-target=".dropdown-toggle.show" target="_blank"> Liquidity </a></li>
                  {/* <li><Link className="dropdown-item" to="/invdash" data-toggle="dropdown" data-target=".dropdown-toggle.show"> Investor Vesting </Link></li> */}
                </ul>
              </li>
              <Nav.Item>
                <ConnectButton
                  isLogin={isLogin}
                  toggleWalletList={toggleWalletList}
                  currentChainId={currentChainId}
                />
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link className="btn btn-brand-header text-nowrap apply-btn" href="https://blockius.typeform.com/to/AcD9kxak" target="_blank"> APPLY</Nav.Link>
              </Nav.Item> */}
            </Nav>
          </Nav>
        </Navbar.Collapse>
        {/* Wallet list modal*/}
        <WalletModal
          show={showWalletList}
          onHide={() => toggleWalletList()}
          onWalletClickHandler={onWalletClickHandler}
          modalLoading={modalLoading}
          onExited={() => setModalLoading(false)}
        />

        {/* loading modal */}

        <LoadingModal
          show={loading && !error}
          onHide={() => dispatch(actions.setLoginLoading(false))}
          title="Please sign the message in your wallet to continue."
          body="Blockpad uses this signature to verify that you’re the owner of this
            Ethereum address."
        />
        {/* <ConnectWallet
        show={connectWalletModalShow}
        onHide={() => setConnectWalletModalShow(false)}
      /> */}
        {/* <AccountDetails
        show={accountDetailsModalShow}
        onHide={() => setAccountDetailsModalShow(false)}
      /> */}
      </Navbar>
    </div>

    // <HeaderStyled>
    //   <nav className="navbar row px-3 ">
    //     <Col xs={{ span: "auto" }}>
    //       <div className="nav-item mr-auto">
    //         <NavLinkStyled exact to="/" activeClassName="active">
    //           <div className="logoWrap">
    //             <div className="logo"><img width={170} src={LogoImg} /></div>
    //             <div className="mobile-logo"><img width={150} src={LogoImg} /></div>
    //           </div>
    //         </NavLinkStyled>
    //       </div>
    //     </Col>
    //     {/* <StakingPools /> */}
    //     <Col
    //       xs={{ span: "auto" }}
    //       style={{ display: "flex", justifyContent: "flex-end" }}
    //       sm={{ order: 3, span: "auto" }}
    //       className="connect-btn-container"
    //     >
    //       <ConnectButton
    //         isLogin={isLogin}
    //         toggleWalletList={toggleWalletList}
    //         currentChainId={currentChainId}
    //       />
    //     </Col>
    //     <Col
    //       className="d-block d-md-none menu-icon"
    //       xs={{ span: "auto", order: 3 }}
    //       onClick={toggleNavbarHandler}
    //     ></Col>
    //   </nav>

    //   {/* Wallet list modal*/}
    //   <WalletModal
    //     show={showWalletList}
    //     onHide={() => toggleWalletList()}
    //     onWalletClickHandler={onWalletClickHandler}
    //     modalLoading={modalLoading}
    //     onExited={() => setModalLoading(false)}
    //   />

    //   {/* loading modal */}

    //   <LoadingModal
    //     show={loading && !error}
    //     onHide={() => dispatch(actions.setLoginLoading(false))}
    //     title="Please sign the message in your wallet to continue."
    //     body="Blockpad uses this signature to verify that you’re the owner of this
    //         Ethereum address."
    //   />
    // </HeaderStyled>
  );
}

export default Header;

Header.propTypes = {
  hasMetamask: PropTypes.bool,
  showWalletList: PropTypes.bool,
  toggleWalletList: PropTypes.func,
  currentChainId: PropTypes.number,
};
